module.exports = "/assets/landing-rc/hero-img-cola.jpg?iiCkV22";